import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './pages/login';
import '../src/pages/genarel.css'
import Onboarding1 from './pages/Onboarding1 ';
import Onboarding2 from './pages/Onboarding2';
import Onboarding3 from './pages/Onboarding3';
import HomePage from './pages/Homepage';
import SplashScreen from './pages/Splashscreen';
import NotificationsPage from './pages/Notificationspage';
import MapPage from './pages/Mappage';
import Events from './pages/events';
import EventDetailPage from './pages/Eventdetailpage';
import BookingPage from './pages/Bookingpage';
import TicketViewPage from './pages/Ticketviewpage';



const Routess = () => {
  return (
    
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/onboarding1" element={<Onboarding1 />} />
        <Route path="/onboarding2" element={<Onboarding2 />} />
        <Route path="/onboarding3" element={<Onboarding3 />} />
        <Route path="/notification" element={<NotificationsPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/events" element={<Events />} />
        <Route path="/details" element={<EventDetailPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/ticket-view" element={<TicketViewPage />} />
     
  
     
      

      </Routes>
    </BrowserRouter>
  );
};

export default Routess;